// HelpBot admin modules;
import app from './app';

const AppAccess = () => {
   var app_access = null;
   if (app.state && app.state.user_access_list && app.state.user_access_list.length) {
      let item = app.state.user_access_list[app.state.user_access_id]
      if (item.user_is_admin) {
         app_access = 'Admin';
      } else if (item.user_is_write) {
         app_access = 'Write';
      } else if (item.user_is_read) {
         app_access = 'Read';
      }
   }
   return(<>{app_access}</>);
} // <AppName />

const AppName = () => {
   var app_name = null;
   if (app.state && app.state.user_access_list && app.state.user_access_list.length) {
      app_name = app.state.user_access_list[app.state.user_access_id].application_name;
   }
   return(<>{app_name}</>);
} // <AppName />

const AppVersion = () => {
   var app_version = null;
   if (app.state && app.state.user_access_list && app.state.user_access_list.length) {
      app_version = app.state.user_access_list[app.state.user_access_id].version_name;
   }
   return(<>{app_version}</>);
} // <AppVersion />

const Foot = () => {

   return(
      <footer className="ask-henry-foot">
        <div className="ask-henry-foot-name ask-henry-ellipsis"><AppName /></div>
        <div className="ask-henry-foot-version ask-henry-ellipsis"><AppVersion /></div>
        <div className="ask-henry-foot-access ask-henry-ellipsis"><AppAccess /></div>
        <div className="ask-henry-foot-status ask-henry-ellipsis">{app.state.status}</div>
      </footer>
   );

} // Foot();

export default Foot;